/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "F:/mobile_v20302/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue";
import Tab from "vux/src/components/tab/tab.vue";
import TabItem from "vux/src/components/tab/tab-item.vue";
import XButton from "vux/src/components/x-button/index.vue";
import Group from "vux/src/components/group/index.vue";
import Cell from "vux/src/components/cell/index.vue";
import Scroll from '@/components/Scroll/Scroll';
export default {
  name: "RepairList",
  components: {
    ViewBox: ViewBox,
    Tab: Tab,
    TabItem: TabItem,
    XButton: XButton,
    Group: Group,
    Cell: Cell,
    Scroll: Scroll
  },
  data: function data() {
    return {
      infoList: [],
      pullDownRefresh: {
        threshold: 40,
        // 下拉多少开始刷新
        stop: 20 // 下拉回弹到多少停住

      },
      pullUpLoad: {
        threshold: 25
      },
      isPullDown: false,
      // 正在下拉刷新
      isPullUp: false,
      // 正在上拉加载
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      emptyShow: false,
      repairState: this.$utils.Store.getItem("repair") || '0'
    };
  },
  computed: {},
  methods: {
    onPullingDown: function onPullingDown() {
      if (this.isPullDown) return;
      this.isPullDown = true; // 下拉刷新

      this.infoList = [];
      this.pageIndex = 1;
      this.getInfoList();
    },
    onPullingUp: function onPullingUp() {
      if (this.isPullUp) return;
      this.isPullUp = true;
      this.pageIndex = this.pageIndex + 1;

      if (this.pageIndex > this.totalPage) {
        this.updateScroll();
        return;
      }

      this.getInfoList();
    },
    updateScroll: function updateScroll(flag) {
      this.isPullDown = false;
      this.isPullUp = false;
      this.$refs.scroll.forceUpdate(flag);
    },
    getInfoList: function getInfoList() {
      var _this = this;

      this.emptyShow = false;
      this.$api.Repairs.selectListPageByEntity({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        search: {
          initiatorUser: this.$utils.Store.getItem("userSerial"),
          repairState: this.repairState
        }
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this.$code.success) {
          _this.$utils.Tools.toastShow(msg);

          _this.updateScroll(false);
        } else {
          var _this$infoList;

          (_this$infoList = _this.infoList).push.apply(_this$infoList, _toConsumableArray(data.records));

          _this.pageIndex = data.pageIndex;
          _this.totalPage = data.totalPage;

          if (_this.infoList.length === 0) {
            _this.emptyShow = true;
          }

          _this.updateScroll(false);
        }
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },
    queryData: function queryData(id) {
      this.$router.push({
        name: 'RepairDetail',
        params: {
          state: id,
          index: this.repairState
        }
      });
    },
    onItemClick: function onItemClick(index) {
      this.repairState = index;
      this.infoList = [];
      this.getInfoList();
    },
    submitData: function submitData() {
      this.$router.push({
        name: 'RepairInfo'
      });
    }
  },
  created: function created() {
    this.getInfoList();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {
    this.$utils.Store.removeItem("repair");
  }
};